import React, { useContext } from "react";
import styled from "styled-components";

import { handleSync, handleLeave } from "../actions";
import { SocketStateContext } from "../../../../provider";
import { Row, Box, Col, Text, Button } from "../../../../comps";
import Menu from "./menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../../theme/theme-provider";

import { faSync, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  align-items: center;
  /* background: ${({ theme }) => theme.color.BLACK_0}; */
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); */
`;

const Line = styled(Box)`
  width: 100%;
  height: 2px;
  background: ${({ theme }) => theme.color.GRAY_1};
`;

export default ({ roomInfo, refresh }) => {
  const [socketInfo] = useContext(SocketStateContext);
  const overlayColor = Theme.color.BLACK_0;
  const overlayTextColor = Theme.textColor.light;

  const { name, id } = roomInfo || {};

  const {
    isJoined,
    room: { id: cri },
  } = socketInfo;
  const isThisRoomJoined = isJoined && cri === id;

  const toggleSync = () => {
    if (isThisRoomJoined) handleLeave();
    else handleSync({ roomInfo });
  };

  return (
    <Wrapper>
      <Text
        marginTop="5px"
        marginBottom="5px"
        marginLegt="5px"
        marginRight="5px"
        color={overlayTextColor}
        fontSize="26px"
      >
        {name}
      </Text>
      <Line />
      <Row style={{ alignItems: "center", marginTop: "10px" }}>
        <Button
          marginRight="12px"
          buttonTextColor={overlayTextColor}
          borderRadius="50"
          buttonBackground={Theme.color.BLUE_3}
          buttonName={isThisRoomJoined ? "Leave" : "Sync"}
          buttonIcon={isThisRoomJoined ? faSignOutAlt : faSync}
          buttonFontSize="14px"
          size="small"
          onClick={toggleSync}
        />
        <Menu refresh={refresh} roomInfo={roomInfo} />
      </Row>
    </Wrapper>
  );
};
